/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
import React, { useEffect } from 'react';

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Image ====== */
import good from '05Images/good.svg'
import error from '05Images/error.svg'
import Xmark from '05Images/Xmark.svg'

/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';
import { snackbarMessage,snackbarApiErrorMessage } from '../../03CommonApiParts/MessageList';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------　スナックバー ------*/
const Sdialog = styled.dialog`//スナックバー本体
    padding:10px;
    background-color: #2e94b9;
    position:fixed;
    z-index:80;
    top: 7%;
    max-width:650px;
	border-radius: 3px;
    border: none;
    color:white;
`;
const SdivContentGroup = styled.div`//スナックバー内容枠
    flex-direction: column;
    margin-left: 10px;
`;
const SpContent = styled.p`//スナックバー内容
    padding:2px 0;
    margin:0px;
    /* line-height:16px; */
    font-weight:bold;
`;  
const SdivContents = styled.div`
        display:flex;
        align-items: center;
        color:white;
`;
const SdivFilm = styled.div`
	position:fixed;//背景
    z-index:80;
    top:0;
	left:0;
    width:100vw;
    height:100vh;
`;
const SsvgIcon = styled.svg`//SVG用
    width:15px;
    height:15px;
`;
const SsvgXIcon = styled.svg`//SVG用
    width:10px;
    height:10px;
    :hover{
        cursor: pointer;
    }
`;

/*==================*/
/*=====  Main  =====*/
/*==================*/
export const SnackBar = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */    
    const {content, set} = props;
    // contentの要素
    // open:   true:表示　false:非表示
    // message: apiからのエラーの時は、resultを指定, それ以外の時は、メッセージidを指定
    // param1: メッセージにパラメータを渡したい時はここに指定（更新件数など）※ただし、受け取れるメッセージは限られる
    // type:   1:APIエラー  2:それ以外    

    /*----- 表示時間を指定 ------*/
    useEffect(()=>{
        if(content.open){
            const timer = (content.level !== 'error') && setTimeout(()=>{
                set({      
                    ...content,
                    open:false,
                    message:null,
                    param1:null,
                    level:null,
                    type:null,
                    afterFunction:null
                });
                content.afterFunction&&(content.afterFunction());
            },2000)

            return () =>{ 
                clearTimeout(timer);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[content])
    

    /*　×ボタン押下処理 */
    const onClickXmark = () =>{
        set({      
            ...content,
            open:false,
            message:null,
            param1:null,
            level:null,
            type:null,
            afterFunction:null
        });
        content.afterFunction&&(content.afterFunction());
    }
    /*------　メッセージの内容を決定　------*/
    const messageContents = (contents) =>{

        let message;
        switch(contents.type){
            case 1://APIエラー時:1,それ以外:2 
                message = snackbarApiErrorMessage(contents.message,contents.$1,contents.$2,contents.$3,contents.$4,contents.$5,contents.$6,contents.$7);
                break;
            case 2://それ以外のメッセージ
                message = snackbarMessage(contents.message, contents.$1,contents.$2,contents.$3,contents.$4,contents.$5,contents.$6,contents.$7);
                break;
            default://デフォルト
                message = 'データがありません。'
        }
        return message;
    }

    /*------　スナックバーカラーを指定　------*/
    const snackbarColor = (contents) => {
        let conts;
        let color;
        switch(contents.type){
            case 1://APIエラー時:1,それ以外:2 
                color = assets().color.snackbarError;
                break;
            case 2://それ以外のメッセージ
            conts = contents.message.slice(3,4);
            switch(conts){
                case 'C':
                    color = assets().color.snackbarSuccess;
                    break;
                case 'I':
                    color = assets().color.snackbarSuccess;
                    break;
                case 'E':
                    color = assets().color.snackbarError;
                    break;
                case 'W':
                    color = assets().color.snackbarWarning;
                    break;
                default:
                    color = assets().color.snackbarError; //APIエラーだった場合はこれになる
                    break;
            };
                break;
            default://デフォルト
            color = assets().color.snackbarError
        };
        return color
    };
    /*------　スナックバーカラーを指定　------*/
    const snackbarIcon = (contents) => {
        let conts;
        let icon;
        switch(contents.type){
            case 1://APIエラー時:1,それ以外:2 
                icon = 'error';
                break;
            case 2://それ以外のメッセージ
            conts = contents.message.slice(3,4);
            switch(conts){
                case 'C':
                    icon = 'success';
                    break;
                case 'I':
                    icon = 'success';
                    break;
                case 'E':
                    icon = 'error';
                    break;
                case 'W':
                    icon = 'error';
                    break;
                default:
                    icon = 'error'; //APIエラーだった場合はこれになる
                    break;
            };
                break;
            default://デフォルト
            icon = 'error';
        };
        return icon
    };

    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */
    return(
        <>
        {/* スナックバー */}
        {content.open?//content.levelがerrorの時、赤色スナックバーを表示する。それ以外は、緑色スナックバー。
            <SdivFilm onClick={snackbarIcon(content) !== 'error' ? onClickXmark : null}>
            <Sdialog 
                open
                style={{backgroundColor: snackbarColor(content)}}>
                    {/* コンテンツ */}
                    <SdivContents>
                        {/* アイコン */}
                        {snackbarIcon(content) === 'error'? 
                        <SsvgIcon>
                            <use xlinkHref={`${error}#error`}></use>
                        </SsvgIcon>
                        :
                        <SsvgIcon>
                            <use xlinkHref={`${good}#good`}></use>
                        </SsvgIcon>}
                        {/* メッセージ */}
                        <SdivContentGroup className='baseText' style={{fontSize:assets().size.baseText}}>
                        {messageContents(content).split('\n').map((str, index) => (
                            <SpContent key={index}>{str}<br /></SpContent>
                        ))}
                        </SdivContentGroup>
                        {snackbarIcon(content) === 'error' &&
                            <SsvgXIcon 
                                className='svgStyle' 
                                style={{height:assets().size.svgHeight,width:assets().size.svgWidth}}
                                onClick={onClickXmark}>
                            <use xlinkHref={`${Xmark}#Xmark`}></use>
                            </SsvgXIcon>
                        }
                    </SdivContents>
            </Sdialog>
            </SdivFilm>
            :''}
        </>
    )
};

//使い方
// const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
//     open:false,
// });

/*------　エラーダイアログ表示　------*/
// setSnackbarMessage({      
//     ...snackbarMessage,
//     open:true,      //スナックバーを開く
//     message:'BC008', //対象のメッセージ　APIエラーの場合はresultを返す
//     type:2,          //APIのエラー（１)かそれ以外(2)か
//     level:'error'    //エラーメッセージの場合はerrorを指定、それ以外はなし
// })

//  <SnackBar
//     content={snackbarMessage}
//     set={setSnackbarMessage}/> 